import { Button, ButtonSize } from '@hourly-hds/components';
import StepLayout from '../StepLayout';

interface CantLoginProps {
  onReturn: () => void;
}

const CantLogin = ({ onReturn }: CantLoginProps) => {
  return (
    <StepLayout>
      <StepLayout.Header>
        <StepLayout.Title>Can’t Login</StepLayout.Title>
        <StepLayout.Description>
          We need both your <strong>email</strong> and <strong>mobile number.</strong> Please
          contact support team at <strong>(844) 800-2211</strong> to provide the missing
          information.
        </StepLayout.Description>
      </StepLayout.Header>
      <StepLayout.Actions>
        <Button label="Return" size={ButtonSize.Large} onClick={onReturn} />
      </StepLayout.Actions>
    </StepLayout>
  );
};

export default CantLogin;
